<template>
  <app-content class="h-panel">
    <div class="flex justify-between mx-16px pt-16px">
      <div class="float-left flex items-center">
        <span style="line-height:32px;">银行科目：</span>
        <Select :datas="subjectList" v-model="params.subjectId" style="width: 250px;margin-right: 16px" @change="handleSubjectChange" :deletable="false">
        </Select>
        <span style="line-height:32px;">截止日期：</span>
        <DatePicker v-model="params.endDate" :clearable="false" @change="loadList" style="width: 120px;margin-right: 16px"/>
      </div>

      <div class="float-right flex items-center">
        <vxe-button @click="exportData" icon="fa fa-download" content="导出"/>
        <vxe-button @click="printData" icon="fa fa-print" content="打印"/>
      </div>
    </div>
    <div class="h-panel-body">
      <div class="text-center mb-16px font-bold text-20px">余额调节表</div>
      <vxe-table height="675"
                 :loading="loading"
                 ref="reconciliationBalanceTable"
                 :data="dataList" border >
        <vxe-column title="项目" field="item1" header-align="center" width="30%"></vxe-column>
        <vxe-column title="金额" field="amount1" header-align="center" align="right" formatter="toMoney" width="20%"/>
        <vxe-column title="项目" field="item2" header-align="center" width="30%"></vxe-column>
        <vxe-column title="金额" field="amount2" header-align="center" align="right" formatter="toMoney" width="20%"/>
      </vxe-table>

    </div>
  </app-content>
</template>

<script>
import BooUtil from "@/views/accountbook/bookUtil";
import accountbook from "@/api/accountbook";
import {downloadBlob} from "download.js";
import manba from "manba";
import {mapGetters, mapState} from "vuex";
import AccountDateRangeChoose from "@/components/AccountDateRangeChoose";
import {clone, findTree, toArrayTree, toTreeArray} from "xe-utils";
import setting from "@/api/setting";
import bankReconciliation from "@api/BankReconciliation";
import Qs from "qs";
import Report from "@api/report";

export default {
  name: "ReconciliationBalance",
  components: {AccountDateRangeChoose},
  data() {
    return {
      subjectList: [],
      dataList: [],
      accountDate: null,
      loading: false,
      params: {
        currencyId: null,
        subjectId: null,
        voucherDate:{
          start: null,
          end: null
        }
      }
    }
  },
  computed: {
    ...mapState(['currentAccountSets']),
    ...mapGetters(['checkoutSelect', 'localCurrency']),
    topData() {
      return this.dataList.filter(val => val.parentTreeId === '0');
    }
  },
  watch: {

  },
  methods: {
    loadBankSubjectList(){
      return setting.subject.bankList().then(({data}) => {
        this.subjectList = data.map(val => {

          return {
            key: val.id,
            title: val.code + ' ' + val.fullName
          }
        })
        if(this.subjectList.length>0){
          this.params.subjectId = this.subjectList[0].key;
          if(this.subjectList[0].hasOwnProperty("endDate") && this.subjectList[0].endDate!=null && this.subjectList[0].endDate!=""){
            this.params.voucherDate.end = this.subjectList[0].endDate;
          }
        }
        this.cloneParams = clone(this.params, true);
      });
    },
    loadList() {
      this.loading = true;
      bankReconciliation.reconciliationBalanceTable(this.params).then(({data}) => {
        this.dataList = data;
      }).finally(() => {
        this.loading = false;
      });
    },
    sfilter(item, val) {
      return item.code.indexOf(val) !== -1 || item.name.indexOf(val) !== -1 || item.mnemonicCode.indexOf(val) !== -1;
    },
    exportData() {
      const utils = new BooUtil(this.$refs.reconciliationBalanceTable, '\n')
      console.log(utils.header)
      console.log(utils.dataList)
      Report.download({
        title: '余额调节表',
        accountSetsName: `账套：${this.currentAccountSets.companyName}`,
        header: utils.header,
        dataList: utils.dataList}).then((data) => {
        downloadBlob(`${manba().format('YYYYMMDDHHmm')}余额调节表.xls`, data)
      })
    },
    printData() {
      const queryStr = Qs.stringify(Object.assign({}, this.params));
      window.open("/api/pdf/reconciliation/balance?"+ queryStr)
    },
    resetForm() {
      this.params = clone(this.cloneParams, true)
    },
    calcTotal({columns, data}) {
      const row = [];
      columns.forEach(col => {
        if ('beginningDebitBalance' === col.property) {
          row.push(this.numFormat(this.topData.filter(val => val.balanceDirection === '借').reduce((total, r) => total + (r.beginBalance || 0), 0)));
        } else if ('beginningCreditBalance' === col.property) {
          row.push(this.numFormat(this.topData.filter(val => val.balanceDirection === '贷').reduce((total, r) => total + (r.beginBalance || 0), 0)));
        } else if ('endingDebitBalance' === col.property) {
          row.push(this.numFormat(this.topData.filter(val => val.balanceDirection === '借').reduce((total, r) => total + (r.endBalance || 0), 0)));
        } else if ('endingCreditBalance' === col.property) {
          row.push(this.numFormat(this.topData.filter(val => val.balanceDirection === '贷').reduce((total, r) => total + (r.endBalance || 0), 0)));
        } else if (!['subjectCode', 'subjectName'].includes(col.property)) {
          row.push(this.numFormat(this.topData.reduce((total, r) => total + (r[col.property] || 0), 0)));
        } else {
          row.push(col.property === "subjectName" ? '合计' : "")
        }
      })
      return [row];
    },
    handleSubjectChange(newSubject){
      if(newSubject.hasOwnProperty("endDate") && newSubject.endDate!=null && newSubject.endDate!=""){
        this.params.endDate = newSubject.endDate;
      }
      this.loadList();
    },
  },

  created() {
    this.params.currencyId = this.localCurrency.id;
    const now = manba();
    this.params.endDate = now.add(-1,manba.MONTH).endOf(manba.MONTH).format();
    this.loadBankSubjectList().then(() =>{
      this.loadList();
    })
  }
}
</script>

<style scoped lang="less">
.balance {
  width: 100%;
  border-collapse: collapse;

  td {
    padding: 0 8px;
    border: 1px solid #e2e2e2;
    font-size: 12px;
    height: 32px;

    &.tip {
      background-color: #FFEEEF;
    }
  }

  tbody tr:nth-child(even) {
    background-color: #f8fbf8;
  }

  tbody tr:hover {
    background-color: #F0F6FF;
  }

  .header {
    td {
      background-color: #F5F5F5;
      text-align: center;
      font-weight: bold;
      height: 35px;
    }
  }
}
</style>
